// extracted by mini-css-extract-plugin
export var price = "Currency-mps-module--price--efe87";